import { useEffect, useState } from "react";
import { toast } from "sonner";
import { SummaryCards } from "./SummaryCards";
import { Filters } from "./Filters";
import { api, errMsg, fmtDate } from "../lib/api";
import { BooksChart } from "./BooksChart";
import { BookCards } from "./BookCards";
import { DailyTable } from "./DailyTable";
import { DailyChart } from "./DailyChart";
import { Button } from "./ui/button";
import { FileDown, FileSpreadsheet } from "lucide-react";
import { exportOverviewExcel } from "../lib/excel";
import { DayDetailDialog } from "./DayDetailDialog";
import { WhatsAppShareButton } from "./WhatsAppShareButton";
import { exportOverviewPdf } from "../lib/pdf";
import { useAuth } from "../context/AuthContext";

export const Overview = ({ onOpenSite, refreshKey }) => {
  const [range, setRange] = useState({ start: "", end: "" });
  const [data, setData] = useState({ sites: [], days: [], total_deposit: 0, total_withdraw: 0, balance: 0 });
  const [day, setDay] = useState(null);
  const { can } = useAuth();

  useEffect(() => {
    const params = { start: range.start || undefined, end: range.end || undefined };
    api.get("/overview", { params }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [range, refreshKey]);

  return (
    <div className="space-y-6" data-testid="overview-dashboard">
      <header className="rise flex flex-col sm:flex-row sm:items-end justify-between gap-2">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-widest text-muted-c">All Books</p>
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">Dashboard</h1>
        </div>
        <div className="flex flex-wrap items-end gap-3">
          <div className="text-left sm:text-right" data-testid="dashboard-date">
            <p className="font-mono text-sm font-semibold">{new Date().toLocaleDateString("en-IN", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}</p>
            <p className="font-mono text-xs text-muted-c" data-testid="dashboard-period">
              Period: {range.start || range.end ? `${range.start ? fmtDate(range.start) : "Beginning"} – ${range.end ? fmtDate(range.end) : "Today"}` : "All dates"}
            </p>
          </div>
          {can("export") && <><Button variant="outline" onClick={() => exportOverviewPdf({ data, start: range.start, end: range.end })} disabled={!data.sites.length}
            className="rounded-none border-brand text-brand bg-transparent hover:bg-brand/10 hover:text-brand/80" data-testid="dashboard-export-pdf-button">
            <FileDown className="h-4 w-4 mr-1" /> Export PDF
          </Button>
          <Button variant="outline" onClick={() => exportOverviewExcel({ data })} disabled={!data.sites.length}
            className="rounded-none border-brand text-brand bg-transparent hover:bg-brand/10 hover:text-brand/80" data-testid="dashboard-export-excel-button">
            <FileSpreadsheet className="h-4 w-4 mr-1" /> Export Excel
          </Button></>}
          {can("share") && <WhatsAppShareButton label="Share Today" testid="whatsapp-share-today-button" />}
        </div>
      </header>
      <Filters start={range.start} end={range.end} setRange={(start, end) => setRange({ start, end })} />
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <BooksChart sites={data.sites} />
        <DailyChart days={data.days} onSelect={setDay} />
      </div>
      <SummaryCards data={data} />
      <BookCards sites={data.sites} onOpenSite={onOpenSite} />
      <DailyTable days={data.days} onSelect={setDay} />
      <DayDetailDialog date={day} onClose={() => setDay(null)} />
    </div>
  );
};
